const DEFAULT_OPEN_MS = 30_000;

let circuitOpenUntil = 0;
let openDurationMs = DEFAULT_OPEN_MS;

export function isPreferencesApiCircuitOpen(): boolean {
  return Date.now() < circuitOpenUntil;
}

export function recordPreferencesServerFailure(status: number): void {
  if (status >= 500) {
    circuitOpenUntil = Date.now() + openDurationMs;
  }
}

export function resetPreferencesApiCircuitForTests(openMs: number = DEFAULT_OPEN_MS): void {
  circuitOpenUntil = 0;
  openDurationMs = openMs;
}

export function getPreferencesCircuitOpenUntilForTests(): number {
  return circuitOpenUntil;
}
